import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProductionVsIrradianceSkeleton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 722,
	height: 248,
	viewBox: "0 0 722 248",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 692,
			y: 3,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 4,
			width: 39,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 42,
			width: 34,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 692,
			y: 74,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 85,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 128,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 692,
			y: 145,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 166,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 43,
			y: 229,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 192,
			y: 229,
			width: 30,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 345,
			y: 229,
			width: 35,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 507,
			y: 229,
			width: 35,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 648,
			y: 229,
			width: 39,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M43 12.5H683",
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 201.5,
				y1: 220,
				x2: 201.5,
				y2: 14,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 362.5,
				y1: 220,
				x2: 362.5,
				y2: 14,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 522.5,
				y1: 220,
				x2: 522.5,
				y2: 14,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 43,
				y1: 51.5,
				x2: 683,
				y2: 51.5,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 43,
				y1: 92.5,
				x2: 683,
				y2: 92.5,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 43,
				y1: 136.5,
				x2: 683,
				y2: 136.5,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 43,
				y1: 176.5,
				x2: 683,
				y2: 176.5,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 1L44 220",
			stroke: "#EDEDED",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M684 1L684 220",
			stroke: "#EDEDED",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M684 220L44 220",
			stroke: "#EDEDED",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgProductionVsIrradianceSkeleton;
